import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const BasicSelectionMarker = ({ hover, selected }) => {
  const hoverClass = hover ? 'basic-select-marker--hovered' : '';
  const selectedClass = selected ? 'basic-select-marker--selected' : '';

  return (
    <label className={`basic-select-marker ${hoverClass} ${selectedClass}`}>
      <span className="basic-select-marker__icon" />
    </label>
  );
};

BasicSelectionMarker.propTypes = {
  hover: PropTypes.bool,
  selected: PropTypes.bool,
};

export default BasicSelectionMarker;
